const Profile = () => {
  return (
    <div>
      <h1>Profile component</h1>
    </div>
  );
};
export default Profile;
